export const buildProvenance = { "commitHash": "f3fafa34a7f0d99b7811224debf350198b00ef84", "branchName": "refs/heads/release/2023.4", "buildDate": "2024-05-23T12:52:58.574Z", "version": "2023.4.8624" };
